import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
  //font-family: Bolton-Bold;
  text-decoration: underline;
`;

export const Underline = ({ children }) => <Wrapper>{children}</Wrapper>;
